import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import "./taost.css"; // Include your custom styles

const MySwal = withReactContent(Swal);

export const showCustomAlert = ({
  title = 'Default Title',
  html = 'Default Content',
  icon = 'info',
  confirmButtonText = 'OK',
  confirmButtonColor = '#af313d',
  background = '#ffffff',
  
  customClass = {},
  showCancelButton = false,
  timer = 2000,
}) => {
  MySwal.fire({
    title: `<strong>${title}</strong>`,
    html,
    icon,
    background,
  
    confirmButtonText,
    confirmButtonColor,
    customClass: {
      popup: 'custom-swal-popup',
      title: 'custom-swal-title ',
      confirmButton: 'custom-swal-confirm-button',
      ...customClass, // Allow additional custom classes
    },
    showCancelButton,
    buttonsStyling: false,
    timer,
  });
};
